import { MapContentLayer } from '../MapContentLayer';
import { CircleLayerSpecification, LayerSpecification } from 'maplibre-gl';
import { MapContentSource } from '../MapContentSource';
import { MapStyles } from '../../../../../configuration/map-styles';

export class StormMarkerCircleLayer extends MapContentLayer {

  constructor(
    source: MapContentSource
  ) {
    super('storm-marker-circle-layer', source);
  }

  toLayerSpecification(): LayerSpecification {
    return {
      id: this.layerId,
      type: 'circle',
      source: this.sourceRef.sourceId,
      paint: {
        'circle-color': '#fff6dc',
        'circle-radius': 13,
        'circle-opacity': 1.0,
        'circle-stroke-width': 2,
        'circle-stroke-color': MapStyles.PAUSED_COLOR,
      },
      visibility: 'visible'
    } as CircleLayerSpecification;
  }
}
